import { Text } from '@mercator-gcp/grout';
import AIMarker from 'components/elements/AIMarker';
import { EmptyField } from 'components/elements/EmptyField';
import { Project } from 'types';
import { formatPrice } from 'utils/format';
import { isNumber } from 'utils/validate';

type TProps = {
  cost?: Project['cost'] | null;
  predictedProjectValue?: Project['predicted_project_value'];
};

const ProjectInfoValue = ({ cost, predictedProjectValue }: TProps) => {
  const numberCost = Number(cost);
  const numberPredictedProjectValue = Number(predictedProjectValue);

  if (isNumber(numberCost) && numberCost > 0) {
    return <Text.Body>{formatPrice(Number(cost))}</Text.Body>;
  }
  if (isNumber(numberPredictedProjectValue) && numberPredictedProjectValue > 0) {
    return (
      <Text.Body>
        {formatPrice(Number(predictedProjectValue))}
        <AIMarker inline />
      </Text.Body>
    );
  }

  return <EmptyField />;
};

export default ProjectInfoValue;
